import axios from 'axios'

export default class YearInReviewApi {
  constructor ({ client }) {
    if (client) {
      this.client = client
    } else {
      this.client = axios.create({
        baseURL: '/eoy',
        headers: { 'Content-Type': 'application/json' },
      })
    }
  }

  getYear (userID, year) {
    return (this.client.get(`/${year}/?valid=1&user_id=${userID}`))
  }
}



// WEBPACK FOOTER //
// ./src/services/yearInReview/api.js